module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"welcome":"Welcome","lang":"lang","tooltipHelp":"Help","tooltipLogout":"Logout","tooltipLogin":"Login"},"fr":{"welcome":"Bienvenue","lang":"lang","tooltipHelp":"Aide","tooltipLogout":"Déconnexion","tooltipLogin":"Se connecter"}}')
  delete Component.options._Ctor
}
